import { compressImage } from '../../utils/compressImage';
import { uploadImagem, previewSemFundoImagem } from '../../services/api';

export const CONCORRENCIA = 3;
export const MAX_PX_UPLOAD = 1600;

export async function enviarFotosProcessador({ fotos, produtoId, onEstado, onPrevia, concorrencia = CONCORRENCIA }) {
    const resultados = new Array(fotos.length).fill(null);
    let proxima = 0;

    const avisar = (idx, estado) => { if (onEstado) onEstado(idx, estado); };

    const processar = async (foto, idx) => {
        avisar(idx, 'enviando');

        let imagemId = null;
        try {
            const arquivo = await compressImage(foto.file, { maxWidth: MAX_PX_UPLOAD, maxHeight: MAX_PX_UPLOAD });
            const res = await uploadImagem({ produto_id: produtoId, arquivo });
            imagemId = res?.data?.id || null;
        } catch (err) {
            imagemId = err?.response?.data?.imagem_id || null;
        }

        if (!imagemId) {
            avisar(idx, 'erro');
            return { erro: 'Não foi possível enviar esta foto.' };
        }

        avisar(idx, 'processando');
        const previa = await previewSemFundoImagem({ imagem_id: imagemId });

        const pronta = previa?.error
            ? { imagem_id: imagemId, url_original: null, url_sem_fundo: null, alerta: previa.error }
            : previa;

        if (onPrevia) onPrevia(idx, pronta);
        return pronta;
    };

    const trabalhador = async () => {
        while (proxima < fotos.length) {
            const idx = proxima++;
            resultados[idx] = await processar(fotos[idx], idx);
        }
    };

    const vagas = Math.max(1, Math.min(concorrencia, fotos.length));
    await Promise.all(Array.from({ length: vagas }, trabalhador));

    return resultados;
}
